<div class="mi-request">

    @if(!isHomePage()){
    <mi-app-header></mi-app-header>
    }
    @else {
    <mi-home-header></mi-home-header>
    }

    <main>
        <div class="mi-request-main">

            <div class="row justify-content-center mi-request-main-header" id="mi-request-main-header">
                <div class="col-md-11">
                    @if(isNeedMainHeader)
                    {
                    <div class="d-none d-sm-flex justify-content-between mc-mt-3">
                        <h1 class="mi-request-main-header-title">
                            {{ requestTitle() }}
                        </h1>
                        <!-- <button>פירוט המוצרים לבקשה</button> -->
                    </div>
                    @if(isNeedProgress)
                    {
                    <mi-app-progress></mi-app-progress>
                    }

                    }

                </div>
            </div>

            <router-outlet />
        </div>
    </main>


</div>
